/*
Copyright 2021-2024 New Vector Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

import { type FC, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { logger } from "matrix-js-sdk/lib/logger";

export const RegisterPage: FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to login page as registration is now handled separately
    navigate("/login")?.catch((error) => {
      logger.error("Failed to navigate to /login", error);
    });
  }, [navigate]);

  return null;
};
